import React from "react";
import { useNavigate } from "react-router-dom";
// import { ShieldOff } from "lucide-react"; // or any icon library you already use

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0c0b0b] text-white px-4">
      <div className="flex flex-col items-center text-center space-y-6">
        <div className="bg-[#1a1a1a] p-8 rounded-2xl shadow-lg flex flex-col items-center space-y-4">
          {/* <ShieldOff size={64} className="text-[#FBB034]" /> */}
          <h1 className="text-4xl font-bold text-[#FBB034]">
            Access Forbidden
          </h1>
          <p className="text-gray-300 max-w-md">
            You don’t have the necessary permissions to view this page.
            <br />
            Please contact your administrator if you believe this is an error.
          </p>

          <div className="flex gap-4 mt-4">
            <button
              onClick={() => navigate(-1)}
              className="px-5 py-2 rounded-md bg-transparent border border-[#FBB034] text-[#FBB034] hover:bg-[#FBB034] hover:text-black transition-all"
            >
              Go Back
            </button>
            <button
              onClick={() => navigate("/admin/dashboard")}
              className="px-5 py-2 rounded-md bg-[#FBB034] text-black font-medium hover:opacity-90 transition-all"
            >
              Go to Dashboard
            </button>
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          Error Code: <span className="text-[#FBB034]">403</span>
        </p>
      </div>
    </div>
  );
};

export default Forbidden;
